import { getBackendUrl } from "@Utils";
import axiosWrapper from "../services/axiosWrapper";
import type {
  UpdateProjectRuleRequest,
  UpdateProjectRuleResponse,
  DeleteProjectRulesRequest,
  DeleteProjectRulesResponse,
  ChangeRulePriorityRequest,
  ChangeRulePriorityResponse,
} from "@ServerTypes/projectRulesController/projectRulesController.schema";
import type { Exact } from "@Helpers/types/exact";

export const updateProjectRules = async <T extends Exact<UpdateProjectRuleRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<UpdateProjectRuleResponse>(
    `${getBackendUrl()}/projectRulesController/updateProjectRule`,
    data,
  );
  return response;
};

export const deleteProjectRules = async <T extends Exact<DeleteProjectRulesRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<DeleteProjectRulesResponse>(
    `${getBackendUrl()}/projectRulesController/deleteProjectRules`,
    data,
  );
  return response;
};

export const changeRulePriority = async <T extends Exact<ChangeRulePriorityRequest, T>>(data: T) => {
  const response = await axiosWrapper.post<ChangeRulePriorityResponse>(
    `${getBackendUrl()}/projectRulesController/changeRulePriority`,
    data,
  );
  return response;
};
